






import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'

@Component({
  components: { TextEllipsis }
})
export default class EllipsisLink extends Vue {
  @Prop() href!: string
}
